import { MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';

type Props<T> = {
  options: T[];
  selected: T;
  setSelected: (nextSelected: T) => void;
  toLabel: (option: T) => React.ReactNode;
  autoWidth?: boolean;
};

export const SelectSimple = <T extends {}>({
  options,
  selected,
  setSelected,
  toLabel,
  autoWidth = true
}: Props<T>) => {
  const [open, setOpen] = useState(false);

  return (
    <Select
      autoWidth={autoWidth}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={options.indexOf(selected)}
      onChange={ev => setSelected(options[Number(ev.target.value)])}
    >
      {options.map((o, i) => (
        <MenuItem key={i} value={i}>
          {toLabel(o)}
        </MenuItem>
      ))}
    </Select>
  );
};
